import React, { ReactElement, ReactNode } from 'react';
import { BootstrapModal } from '../../BootstrapModal/BootstrapModal';
import { ModalHeader, ModalBody, ModalFooter } from '../Helpers/index';
import './Dialog.scss';

/**
 * A simple React wrapper component for BootstrapModal to display a modal dialog.
 *
 * Potential code duplication: ReactModalDialog/ModalDialog/Dialog/BootstrapModal
 */

const ModalDialogWrappingCompDefaults = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => <>{children}</>;

export const Dialog: React.FC<{
  ModalDialogWrappingComp?: typeof React.Component;
  children: ReactNode;
  center?: boolean;
  small?: boolean;
  show: boolean;
  title: string;
  dialogClassName: string;
  actions: { label: string; onClick: () => void }[];
  showClose?: boolean;
  showSpinner?: boolean;
  disabled?: boolean;
  onHide: () => void;
}> = React.memo(
  ({ ModalDialogWrappingComp = ModalDialogWrappingCompDefaults, ...props }) => {
    return (
      <BootstrapModal {...props}>
        <ModalDialogWrappingComp>
          <div className={'modal-dialog'}>
            <ModalHeader
              {...{
                title: props.title,
                showClose: props.showClose,
                onHide: props.onHide,
              }}
            />
            <ModalBody>{props.children}</ModalBody>
            <ModalFooter
              {...{
                actions: props.actions,
                showSpinner: props.showSpinner,
                disabled: props.disabled,
              }}
            />
          </div>
        </ModalDialogWrappingComp>
      </BootstrapModal>
    );
  }
);
